export default __webpack_public_path__ + "static/media/diploma.70a397ce.jpg";